import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { getIsDistanceCalculatingEnabled, hasFutureObjects } from 'shared/containers/NewbuildingMapContainer/utils';
import { getIsTransportAccessibilityServiceAvailable, getRegularInfrastructure } from 'shared/selectors/newbuildingMap';
import { EMapService } from 'shared/types/map';

export const useMapServices = () => {
  const { config } = useApplicationContext();

  const regularInfrastructure = useSelector(getRegularInfrastructure);

  const isFutureInfrastructureServiceAvailable = hasFutureObjects(regularInfrastructure);
  const isTransportAccessibilityServiceAvailable = useSelector(getIsTransportAccessibilityServiceAvailable);
  const isRouteServiceAvailable = getIsDistanceCalculatingEnabled(config);

  const services: EMapService[] = [];

  if (isFutureInfrastructureServiceAvailable) {
    services.push(EMapService.FutureInfrastructure);
  }

  if (isTransportAccessibilityServiceAvailable) {
    services.push(EMapService.TransportAccessibility);
  }

  if (isRouteServiceAvailable) {
    services.push(EMapService.Routes);
  }

  return services;
};
